// component
import { Helmet } from "react-helmet-async";
import { Navbar1 } from '../../../components/navbars';
import BackToTop from '../../../components/BackToTop';
import { Footer1 } from '../../../components/footer';

import About from './About';
import Feature from './Feature';
import Counter from './Counter';
import Team from './Team';
import Client from './Client';
import { benefits } from './data';

// dummy data
import { teamMembers } from './data';
import Benefits from './Benefits';
import HeroAbout from './HeroAbout';

const Company = () => {
    return (
        <>

            <div className='header-7 '>
            </div>

            <About />

            {/* <Feature /> */}
            <Benefits benefits={benefits} />


            {/* <Footer1 /> */}

            {/* <BackToTop variant="info" /> */}
            {/* </div> */}
        </>
    );
};

export default Company;
